import React from "react";
import MainPageLayout from "../layouts/MainPageLayout";

const InvestorRelations = () => {

  
  return (
    <>
      <MainPageLayout
        pageEndpoint={"pages?filters[slug][$eq]=investor-relations"}
      />
    </>
  );
};

export default InvestorRelations;
